import React, { useEffect, useState } from 'react';

const CardReaderInput = () => {
  const [cardData, setCardData] = useState('');
  const [isReading, setIsReading] = useState(false);
  let buffer = '';

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isReading) return;

      if (e.key === 'Enter') {
        setCardData(buffer);
        buffer = '';
        setIsReading(false); // Optional: auto-stop reading
      } else {
        buffer += e.key;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isReading]);

  return (
    <div style={{ padding: '20px' }}>
      <button onClick={() => setIsReading(true)}>Start Reading</button>
      <p><strong>Card Data:</strong> {cardData}</p>
    </div>
  );
};

export default CardReaderInput;
